module.exports = __webpack_public_path__ + "img/gxdz_title.596c220d.png";